<template>
  <div>
    <hr class="emd-divider" />
    <div class="eu-pa_3 eu-pa_5_md">
      <div class="eu-flex eu-pb_5">
        <span class="summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2">{{ $t('linkName') }}</span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md">{{ paymentLinkData.name || '-' }}</span>
      </div>
      <div class="eu-flex eu-pb_5">
        <span class="summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2">{{ $t('expirationTime') }}</span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md">{{ expiresIn }}</span>
      </div>
      <div class="eu-flex">
        <span class="summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2">{{ $t('paymentLimit') }}</span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md">{{ paymentLinkData.max_paid_sessions || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import { INTERVAL_ENUM } from '../../../enums/expiration.enum.js'
export default {
  name: 'Link',
  computed: {
    paymentLinkData () {
      return this.$store.getters.paymentLinkData
    },
    isCustom () {
      return this.paymentLinkData.selectedExpiresIn === INTERVAL_ENUM.CUSTOM.label
    },
    expiresIn () {
      const { expiresInPeriod, expiresInValue } = this.paymentLinkData
      if (!this.isCustom) { return this.$t(this.paymentLinkData.selectedExpiresIn) }

      return `${expiresInValue} ${this.$tc(expiresInPeriod, expiresInValue)}`
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "linkName": "Nome do link",
    "expirationTime": "Tempo de expiração",
    "paymentLimit": "Limite de pagamentos",
    "custom": "Personalizado",
    "none": "Não expira",
    "one_hour": "1 hora",
    "twelve_hours": "12 horas",
    "one_day": "1 dia",
    "one_hour": "1 hora",
    "one_week": "1 semana",
    "fifteen_days": "15 dias",
    "one_month": "1 mês",

    "years": "ano | anos",
    "months": "mês | meses",
    "weeks": "semana | semanas",
    "days": "dia | dias",
    "hours": "hora | horas",
    "minutes": "minuto | minutos"
  },
  "en-US": {
    "linkName": "Link name",
    "expirationTime": "Expiration time",
    "paymentLimit": "Payment limit",
    "custom": "Custom",
    "none": "Doesn't expire",
    "oneHour": "1 hour",
    "twelveHours": "12 hours",
    "oneDay": "1 day",
    "one_hour": "1 hour",
    "one_week": "1 week",
    "fifteenDays": "15 days",
    "oneMonth": "1 month",
    "noLimit": "No limit",

    "years": "year | years",
    "months": "month | months",
    "weeks": "week | weeks",
    "days": "day | days",
    "hours": "hour | hours",
    "minutes": "minute | minutes"
  }
}
</i18n>
